import {
    Component,
    Element,
    getAssetPath,
    h,
    Host,
    Prop,
    Watch,
} from "@stencil/core";

@Component({
    tag: "ux-iws-sf-page",
    styleUrl: "sf-page.scss",
    assetsDirs: ["./assets"],
    shadow: false,
})
export class SfPage {
    @Element() element: HTMLUxIwsSfPageElement;

    /** Variant of the page component */
    @Prop({ reflect: true }) variant: "center" | "center-blue" | string =
        "center";

    /** Indicates if the page should cover the full screen height */
    @Prop({ reflect: true }) fullHeight: boolean = false;

    @Watch("variant")
    handleVariant() {
        if (["center-blue"].includes(this.variant)) {
            this.element.style.setProperty(
                `--ux-sf-background-image`,
                `url(${getAssetPath(`./assets/sf-page-${this.variant}.jpg`)})`
            );
        } else {
            this.element.style.removeProperty(`--ux-sf-background-image`);
        }
    }

    componentWillLoad() {
        this.handleVariant();
    }

    render() {
        return (
            <Host>
                <slot />
            </Host>
        );
    }
}
